import { cn } from 'lib/utils';
import { FC } from 'react';
import { uiSimpleBox } from '../CutCorners';

interface BPGradientBoxProps {
  twGradientFromTo?: string;
}

const BPGradientBox: FC<BPGradientBoxProps> = ({
  twGradientFromTo = 'from-white/30 to-white/10',
}) => (
  <div
    className={cn(
      'block absolute top-0 left-0 w-full h-full bg-gradient-to-b',
      twGradientFromTo,
      uiSimpleBox.border
    )}
  />
);

export default BPGradientBox;
